var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fast-editor-page",attrs:{"id":"fast-editor-page"}})}
var staticRenderFns = []

export { render, staticRenderFns }